export default "__VITE_ASSET__DZeLu2wq__"